import React, { useEffect, useRef, useImperativeHandle, forwardRef } from "react";
import { RxCross2 } from "react-icons/rx";
import { GoSun } from "react-icons/go";
import { BsMoonStars } from "react-icons/bs";
import LanguageSwitcher from "../../LanguageSwitcher";
import { applyTheme, updateAllCharts, updateImages } from "../../../utils/theme";
import { createRoot } from "react-dom/client";
import { useSearchParams } from "react-router-dom";

let elementInstances = {};
const SidebarMobileHeader = ({
  username,
  userEmail,
  theme,
  onViewInfoClick,
  handleLogout,
  onClose,
  isChecked,
  handleToggleChange,
  callingFrom,
}) => {
  const [searchParams] = useSearchParams();
  const nativeTheme = searchParams.get("theme") || theme;
  theme = localStorage.getItem("webView") === "true" ? nativeTheme : localStorage.getItem("theme") || theme
  // theme = localStorage.getItem("theme") || theme;
  const iconContainerRef = useRef(null);
  const iconRootRef = useRef(null);
  const userAgent = navigator.userAgent || "";
  const isNativeApp = localStorage.getItem("webView") === "true" || userAgent.includes("EDPFlutterApp");
  const updateTheme = (event) => {
    let newTheme = event.detail;
    theme = newTheme;

    applyTheme(elementInstances, theme, "SidebarMobileHeader")
    //updateImages(theme);
  };
  const renderThemeIcon = () => {
    const currentTheme = localStorage.getItem("theme") || "light";
    const icon = currentTheme === "dark" ? (
      <GoSun className="me-2" style={{ color: "#ffffff" }} size={23} />
    ) : (
      <BsMoonStars className="me-2" style={{ color: "#575353" }} size={21} />
    );

    if (iconContainerRef.current) {
      if (!iconRootRef.current) {
        iconRootRef.current = createRoot(iconContainerRef.current);
      }
      iconRootRef.current.render(icon);
    }
  };

  useEffect(() => {
    renderThemeIcon(); // Initial render
    window.addEventListener("themeChanged", renderThemeIcon);
    window.addEventListener("themeChanged", updateTheme); // Your existing handler

    return () => {
      window.removeEventListener("themeChanged", renderThemeIcon);
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, []);
  return (
    <div>
      {/* Close Button */}
      <div className="col-sm-12 text-right">
        <RxCross2
          size={22}
          onClick={onClose}
          ref={(el) => { if (el) elementInstances["svg"] = el; }}
          style={{ color: theme === "dark" ? "#fff" : "inherit" }}
        />
      </div>

      {/* User Info Section */}
      <div className="col-sm-12 infoSection-Sidebar-mobile">
        <div className="row mt-1 mobile-Sidebar-Infoheading">
          <div
            className="col-sm-12 name-text omnes-medium-font"
            ref={(el) => { if (el) elementInstances["div1"] = el; }}
            style={{ color: theme === "dark" ? "#fff" : "inherit" }}
          >
            {username}
          </div>
          <div
            className="col-sm-12 email-text omnes-regular-font"
            ref={(el) => { if (el) elementInstances["div2"] = el; }}
            style={{ color: theme === "dark" ? "#fff" : "inherit" }}
          >
            {userEmail}
          </div>
        </div>
        {!isNativeApp && <div className={`d-flex align-items-center sdm cf-${callingFrom}`}>
          <div className="btn-container myinfo-btn mt-3 mb-2">
            <button
              type="button"
              className="btn btn-success"
              onClick={onViewInfoClick}
            >
              View Info
            </button>
          </div>
          <div className="btn-container myinfo-btn mt-3 mb-2">
            <button
              type="button"
              className="btn btn-logout"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>}
      </div>

      <hr className="m-3" />

      {/* Theme and Language Section */}
      <div className="col-sm-12 theme-langSection-Sidebar pe-3 ps-3">
        <div className="col-sm-12 setting-item drModeChk1">
          <div className="icon-text d-flex align-items-center">
            {/* <span className="icon">
              {theme === "dark" ? (
                <GoSun
                  className="me-2"
                  style={{ color: "#ffffff" }}
                  size={23}
                />
              ) : (
                <BsMoonStars
                  className="me-2"
                  style={{ color: "#575353" }}
                  size={21}
                />
              )}
            </span> */}
            <span className="icon" ref={iconContainerRef}></span>
            <span className="modetext">
              {theme === "dark" ? "Light Mode" : "Dark Mode"}
            </span>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleToggleChange}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="col-sm-12">
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  );
};

export default SidebarMobileHeader;
